import { Column } from '@iw/core/entities';

export const ONGOING_ORDERS_COLUMNS: Column[] = [
  {
    name: 'created',
    i18nKey: 'ordersHistory.table.created',
    sortable: false,
  },
  {
    name: 'changed',
    i18nKey: 'ordersHistory.table.changed',
    sortable: false,
  },
  {
    name: 'method',
    i18nKey: 'ordersHistory.table.method',
    sortable: false,
  },
  {
    name: 'status',
    i18nKey: 'ordersHistory.table.status',
    sortable: false,
  },
  {
    name: 'currency',
    i18nKey: 'ordersHistory.table.currency',
    sortable: false,
  },
  {
    name: 'amount',
    i18nKey: 'ordersHistory.table.amount',
    sortable: false,
  },
  {
    name: 'chat',
    i18nKey: 'ordersHistory.table.chat',
    sortable: false,
  },
];

export const ORDERS_COLUMNS: Column[] = [
  {
    name: 'created',
    i18nKey: 'ordersHistory.table.created',
    sortable: false,
  },
  {
    name: 'completed',
    i18nKey: 'ordersHistory.table.completed',
    sortable: false,
  },
  {
    name: 'method',
    i18nKey: 'ordersHistory.table.method',
    sortable: false,
  },
  {
    name: 'status',
    i18nKey: 'ordersHistory.table.status',
    sortable: false,
  },
  {
    name: 'currency',
    i18nKey: 'ordersHistory.table.currency',
    sortable: false,
  },
  {
    name: 'amount',
    i18nKey: 'ordersHistory.table.amount',
    sortable: false,
  },
  {
    name: 'chat',
    i18nKey: 'ordersHistory.table.chat',
    sortable: false,
  },
];
